import React from 'react';
import { Col } from "reactstrap";

export default class CheckboxArea extends React.Component {
    constructor(props) {
        super(props);
    }

    handleClick = () => this.props.onClick(this.props.index)

    render() {
    	return (
            <Col className={ `checkbox-area ${this.props.className?this.props.className:""}` }
                 xs={this.props.xs ? this.props.xs : 'auto'}
                 sm={this.props.sm ? this.props.sm : 'auto'} 
                 md={this.props.md ? this.props.md : 'auto'} >
                <div className="card-branco" onClick={ this.handleClick }>
                    { this.props.titulo && <div className="titulo">{ this.props.titulo }</div> }
                    <label className="control control-checkbox float-left">
                        <span><input type="checkbox" onChange={ this.handleChange } checked={ this.props.checked }/>
                        <div className="control_indicator" onClick={ this.handleClick }></div></span>
                        <div className="clearboth"></div>
                    </label>
                    { this.props.mensagem && <div className="mensagem">{ this.props.mensagem }</div> }
                </div>
            </Col>
        );
    }
}


// WEBPACK FOOTER //
// ./src/modules/comum/components/CheckboxArea.js